// extracted by mini-css-extract-plugin
export var callCard = "_rl-0";
export var callMessageButton = "_rl-1";
export var helpIcon = "_rl-3";
export var helpIconContainer = "_rl-4";
export var verticalDivider = "_rl-2";